import { render, staticRenderFns } from "./EditTransportationDocumentPage.vue?vue&type=template&id=84475402&scoped=true"
import script from "./EditTransportationDocumentPage.vue?vue&type=script&lang=js"
export * from "./EditTransportationDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84475402",
  null
  
)

export default component.exports